import * as React from 'react';
import RegionForm from "../../components/Price/PriceForm/PriceForm";
var Price = function () {
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432 \u0433\u0440\u0430\u0444\u0438\u043A \u0446\u0435\u043D\u0438"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: " offset-md-4 col-md-5" },
                    React.createElement(RegionForm, null))))));
};
export default Price;



//////////////////
// WEBPACK FOOTER
// ./src/views/Prices/Price.tsx
// module id = 546
// module chunks = 0